/**
 * Nova chat widget — public entry point.
 *
 * Usage:
 * ```ts
 * import { initWidget } from '@nova/sdk/widget';
 *
 * const widget = initWidget({
 *   apiUrl: 'https://api.nova.example.com',
 *   apiKey: 'key_...',
 *   apiSecret: 'secret_...',
 *   appId: 'app-001',
 *   externalUserId: 'user-42',
 *   triggerSelector: '#support-btn',
 * });
 *
 * // Programmatic control
 * widget.open();
 * widget.close();
 * widget.destroy();
 * ```
 */

import { NovaChatWidget, type WidgetConfig } from './chat-widget.js';

/**
 * Initialize a new Nova chat widget and attach it to the DOM.
 *
 * @param config - Widget configuration including API credentials and options.
 * @returns A {@link NovaChatWidget} instance with open/close/toggle/destroy methods.
 */
export function initWidget(config: WidgetConfig): NovaChatWidget {
  return new NovaChatWidget(config);
}

export { NovaChatWidget, type WidgetConfig };
